import React from "react";
import Icon from "../zest/Icon";

const pad = (number: number): string => String(number).padStart(2, "0");

const toIsoDate = (date: Date): string => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

const addDays = (isoDate: string, days: number): string => {
  const date = new Date(`${isoDate}T00:00:00`);
  date.setDate(date.getDate() + days);
  return toIsoDate(date);
};

const formatDate = (isoDate: string): string =>
  new Date(`${isoDate}T00:00:00`).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });

export interface DateSelectorProps {
  date: string;
  onChange: (isoDate: string) => void;
}

const DateSelector = ({ date, onChange }: DateSelectorProps): JSX.Element => (
  <div className="flex items-center gap-4 text-primary">
    <button type="button" aria-label="Previous day" onClick={() => onChange(addDays(date, -1))}>
      <Icon icon="circle-left" size="xl" />
    </button>
    <span className="text-primary font-semibold">{formatDate(date)}</span>
    <button type="button" aria-label="Next day" onClick={() => onChange(addDays(date, 1))}>
      <Icon icon="circle-right" size="xl" />
    </button>
  </div>
);

export default DateSelector;
